import { useEffect } from 'react';

import { DrawerStep, useDrawerSteps } from '@/features/Dashboard/drawer/context/DrawerStepsContext';
import { clearPendingAddAppDrawer } from '@/features/SymbolSelector/store/symbolSelector.slice';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';

/**
 * Bridges the Redux `pendingAddAppDrawer` flag (set by the floating SymbolSelector
 * toolbar's "Create app" button) into the Dashboard's DrawerStepsContext.
 * Must be rendered inside DrawerStepsProvider.
 */
const DrawerOpenRequestHandler = () => {
  const pendingAddAppDrawer = useAppSelector(s => s.symbolSelector.pendingAddAppDrawer);
  const { setDrawerStep, drawerStep } = useDrawerSteps();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (pendingAddAppDrawer && !drawerStep) {
      setDrawerStep(DrawerStep.SelectApp);
      dispatch(clearPendingAddAppDrawer());
    }
  }, [pendingAddAppDrawer, drawerStep, setDrawerStep, dispatch]);

  return null;
};

export default DrawerOpenRequestHandler;
